var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props),
    React.createElement("path", { fill: "#303030", fillRule: "evenodd", d: "M8 2C5.482 2 3.5 3.679 3.5 6.5c0 2.002 1.37 4.385 4.15 7.123.194.191.506.191.7 0 2.78-2.738 4.15-5.121 4.15-7.123C12.5 3.679 10.518 2 8 2zm0-1c3.037 0 5.5 2.086 5.5 5.5 0 2.325-1.496 4.928-4.447 7.835-.584.575-1.522.575-2.106 0C3.996 11.428 2.5 8.825 2.5 6.5 2.5 3.086 4.963 1 8 1zm0 8C6.62 9 5.5 7.88 5.5 6.5S6.62 4 8 4s2.5 1.12 2.5 2.5S9.38 9 8 9zm0-1c.828 0 1.5-.672 1.5-1.5S8.828 5 8 5s-1.5.672-1.5 1.5S7.172 8 8 8z" })
  );
});